import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, ChangeDetectionStrategy, Input, Output, ViewChild, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { fromEvent } from 'rxjs';

class NgxFittextService {
    constructor() { }
}
NgxFittextService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: NgxFittextService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NgxFittextService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: NgxFittextService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: NgxFittextService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class NgxFittextComponent {
    constructor() { }
    ngOnInit() {
    }
}
NgxFittextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: NgxFittextComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NgxFittextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.0", type: NgxFittextComponent, selector: "lib-ngx-fittext", ngImport: i0, template: `
    <p>
      ngx-fittext works!
    </p>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: NgxFittextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-ngx-fittext',
                    template: `
    <p>
      ngx-fittext works!
    </p>
  `,
                    styles: []
                }]
        }], ctorParameters: function () { return []; } });

class FitLineComponent {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.stepSize = 2;
        this.calcOnResize = false;
        this.minFontSize = 10;
        this.maxFontSize = 500;
        this.showInfo = new EventEmitter();
    }
    ngAfterViewInit() {
        //resize event
        if (this.calcOnResize) {
            this.resizeObservable$ = fromEvent(window, 'resize');
            this.resizeSubscription$ = this.resizeObservable$.subscribe((evt) => {
                this.fitToLine();
            });
        }
        // sometimes cant calculate after view init, i set timeout to fix it
        setTimeout(() => {
            this.fitToLine();
        }, 20);
    }
    ngOnDestroy() {
        // unsubscribe resize event
        this.resizeSubscription$.unsubscribe();
    }
    // fitting line calculation
    fitToLine(delay) {
        return __awaiter(this, void 0, void 0, function* () {
            this.renderer.setStyle(this.el.nativeElement, 'opacity', 0);
            // refreshing need delay
            if (delay) {
                yield this.delayView(delay);
            }
            // get child elements
            this.elChildren = this.el.nativeElement.childNodes;
            // resize child elements
            for (let index = 0; index < this.elChildren.length; index++) {
                const element = this.el.nativeElement.childNodes[index];
                this.renderer.setStyle(element, 'white-space', `nowrap`);
                const fs = getComputedStyle(element).getPropertyValue('font-size');
                const { size, unit } = this.splitFontSize(fs);
                // if overflow descrease font size
                if (this.isOverflow(element)) {
                    this.resizeToSmall(element, size, unit);
                }
                else {
                    // increase font size
                    this.resizeToBig(element, size, unit);
                }
            }
        });
    }
    resizeToSmall(htmlEl, fontSize, unit) {
        while (this.isOverflow(htmlEl)) {
            fontSize -= this.stepSize;
            if (fontSize <= this.minFontSize) {
                this.renderer.setStyle(htmlEl, 'font-size', `${this.minFontSize}${unit}`);
                this.renderer.setStyle(htmlEl, 'white-space', `normal`);
                this.showInfo.emit({
                    fontSize: this.minFontSize + unit,
                    effectedHtm: htmlEl,
                });
                break;
            }
            this.renderer.setStyle(htmlEl, 'font-size', `${fontSize}${unit}`);
            this.showInfo.emit({
                fontSize: this.minFontSize + unit,
                effectedHtm: htmlEl,
            });
        }
        this.renderer.setStyle(this.el.nativeElement, 'opacity', 1);
    }
    resizeToBig(htmlEl, fontSize, unit) {
        while (!this.isOverflow(htmlEl)) {
            fontSize += this.stepSize;
            this.renderer.setStyle(htmlEl, 'font-size', `${fontSize}${unit}`);
            if (this.isOverflow(htmlEl)) {
                fontSize -= this.stepSize;
                this.renderer.setStyle(htmlEl, 'font-size', `${fontSize}${unit}`);
                this.showInfo.emit({
                    fontSize: this.minFontSize + unit,
                    effectedHtm: htmlEl,
                });
                break;
            }
            if (fontSize >= this.maxFontSize) {
                this.renderer.setStyle(htmlEl, 'font-size', `${this.maxFontSize}${unit}`);
                this.showInfo.emit({
                    fontSize: this.minFontSize + unit,
                    effectedHtm: htmlEl,
                });
                break;
            }
            this.showInfo.emit({
                fontSize: this.minFontSize + unit,
                effectedHtm: htmlEl,
            });
        }
        // if calculated font size smaller than min font size
        if (fontSize <= this.minFontSize) {
            this.renderer.setStyle(htmlEl, 'font-size', `${this.minFontSize}${unit}`);
            this.renderer.setStyle(htmlEl, 'white-space', `normal`);
            this.showInfo.emit({
                fontSize: this.minFontSize + unit,
                effectedHtm: htmlEl,
            });
        }
        this.renderer.setStyle(this.el.nativeElement, 'opacity', 1);
    }
    // refresh if text changed programmatically
    refreshText() {
        this.fitToLine(10);
    }
    isOverflow(htmlEl) {
        return htmlEl.scrollWidth > htmlEl.offsetWidth;
    }
    splitFontSize(fs) {
        const size = fs.match(/\d+/g);
        const unit = fs.match(/[a-zA-Z]+/g);
        return {
            size: size ? Number(size[0]) : 2,
            unit: unit ? unit[0] : 'px',
        };
    }
    delayView(delayMs) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(resolve, delayMs));
        });
    }
}
FitLineComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: FitLineComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
FitLineComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.0", type: FitLineComponent, selector: "fit-line", inputs: { stepSize: "stepSize", calcOnResize: "calcOnResize", minFontSize: "minFontSize", maxFontSize: "maxFontSize" }, outputs: { showInfo: "showInfo" }, ngImport: i0, template: "<ng-content></ng-content>\r\n", styles: [":host ::ng-deep *{white-space:nowrap}"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: FitLineComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fit-line',
                    templateUrl: './fit-line.component.html',
                    styleUrls: ['./fit-line.component.css'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { stepSize: [{
                type: Input
            }], calcOnResize: [{
                type: Input
            }], minFontSize: [{
                type: Input
            }], maxFontSize: [{
                type: Input
            }], showInfo: [{
                type: Output
            }] } });

class FitTextComponent {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
        this.stepSize = 2;
        this.calcOnResize = false;
        this.minFontSize = 10;
        this.maxFontSize = 500;
        this.showInfo = new EventEmitter();
    }
    ngAfterViewInit() {
        //resize event
        if (this.calcOnResize) {
            this.resizeObservable$ = fromEvent(window, 'resize');
            this.resizeSubscription$ = this.resizeObservable$.subscribe((evt) => {
                this.fitToBox();
            });
        }
        this.fitToBox(20);
    }
    ngOnDestroy() {
        // unsubscribe resize event
        this.resizeSubscription$.unsubscribe();
    }
    fitToBox(delay) {
        return __awaiter(this, void 0, void 0, function* () {
            // prevent overflow text when resizing
            this.renderer.setStyle(this.controllerDiv.nativeElement, 'opacity', 0);
            // refreshing need delay
            if (delay) {
                yield this.delayView(delay);
            }
            this.renderer.setStyle(this.el.nativeElement, 'width', this.width || '100%');
            this.renderer.setStyle(this.el.nativeElement, 'height', this.height);
            const wrapperWidth = this.el.nativeElement.offsetWidth;
            const wrapperHeight = this.el.nativeElement.offsetHeight;
            const controllerWidth = this.controllerDiv.nativeElement.offsetWidth;
            const controllerHeight = this.controllerDiv.nativeElement.offsetHeight;
            const scrollWidth = this.controllerDiv.nativeElement.scrollWidth;
            const scrollHeight = this.controllerDiv.nativeElement.scrollHeight;
            if (wrapperWidth < controllerWidth ||
                wrapperHeight < controllerHeight ||
                scrollWidth < controllerWidth ||
                scrollHeight < controllerHeight) {
                this.resizeToSmall();
            }
            else {
                this.resizeToBig();
            }
        });
    }
    // refresh if text changed programmatically
    refreshText() {
        this.fitToBox(50);
    }
    resizeToSmall() {
        while (this.el.nativeElement.offsetWidth <
            this.controllerDiv.nativeElement.offsetWidth ||
            this.el.nativeElement.offsetHeight <
                this.controllerDiv.nativeElement.offsetHeight ||
            this.controllerDiv.nativeElement.offsetHeight <
                this.controllerDiv.nativeElement.scrollHeight ||
            this.controllerDiv.nativeElement.offsetWidth <
                this.controllerDiv.nativeElement.scrollWidth) {
            const fs = getComputedStyle(this.controllerDiv.nativeElement).getPropertyValue('font-size');
            const { size, unit } = this.splitFontSize(fs);
            let fontSize = size;
            if (fontSize <= this.minFontSize) {
                break;
            }
            fontSize -= this.stepSize;
            this.renderer.setStyle(this.controllerDiv.nativeElement, 'font-size', `${fontSize}${unit}`);
            this.showInfo.emit({
                fontSize: `${fontSize}${unit}`,
            });
        }
        this.renderer.setStyle(this.controllerDiv.nativeElement, 'opacity', 1);
    }
    resizeToBig() {
        while (this.controllerDiv.nativeElement.offsetWidth <=
            this.el.nativeElement.offsetWidth ||
            this.controllerDiv.nativeElement.offsetHeight <=
                this.el.nativeElement.offsetHeight) {
            const fs = getComputedStyle(this.controllerDiv.nativeElement).getPropertyValue('font-size');
            const { size, unit } = this.splitFontSize(fs);
            let fontSize = size;
            if (fontSize >= this.maxFontSize) {
                break;
            }
            fontSize += this.stepSize;
            // console.log({fontSize,divHeight:this.controllerDiv.nativeElement.offsetHeight,elHeight: this.el.nativeElement.offsetHeight})
            this.renderer.setStyle(this.controllerDiv.nativeElement, 'font-size', `${fontSize}${unit}`);
            this.showInfo.emit({
                fontSize: `${fontSize}${unit}`,
            });
            if (this.controllerDiv.nativeElement.offsetWidth >
                this.el.nativeElement.offsetWidth ||
                this.controllerDiv.nativeElement.offsetHeight >
                    this.el.nativeElement.offsetHeight ||
                this.controllerDiv.nativeElement.scrollHeight >
                    this.controllerDiv.nativeElement.offsetHeight + 1 ||
                this.el.nativeElement.scrollWidth > this.el.nativeElement.offsetWidth) {
                // console.log("over",{fontSize,divHeight:this.controllerDiv.nativeElement.offsetHeight,elHeight: this.el.nativeElement.offsetHeight,cSH:this.controllerDiv.nativeElement.scrollHeight})
                fontSize -= this.stepSize;
                this.renderer.setStyle(this.controllerDiv.nativeElement, 'font-size', `${fontSize}${unit}`);
                this.showInfo.emit({
                    fontSize: `${fontSize}${unit}`,
                });
                break;
            }
        }
        this.renderer.setStyle(this.controllerDiv.nativeElement, 'opacity', 1);
    }
    splitFontSize(fs) {
        const size = fs.match(/\d+/g);
        const unit = fs.match(/[a-zA-Z]+/g);
        return {
            size: size ? Number(size[0]) : 2,
            unit: unit ? unit[0] : 'px',
        };
    }
    delayView(delayMs) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(resolve, delayMs));
        });
    }
}
FitTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: FitTextComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FitTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.0", type: FitTextComponent, selector: "fit-text[height]", inputs: { stepSize: "stepSize", calcOnResize: "calcOnResize", minFontSize: "minFontSize", maxFontSize: "maxFontSize", height: "height", width: "width" }, outputs: { showInfo: "showInfo" }, viewQueries: [{ propertyName: "controllerDiv", first: true, predicate: ["controllerDiv"], descendants: true }], ngImport: i0, template: "\n  <div\n    #controllerDiv\n  >\n    <ng-content></ng-content>\n  </div>\n\n", styles: [":host{display:flex;position:relative;margin:0;padding:0}"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: FitTextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fit-text[height]',
                    templateUrl: './fit-text.component.html',
                    styleUrls: ['./fit-text.component.css'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { stepSize: [{
                type: Input
            }], calcOnResize: [{
                type: Input
            }], minFontSize: [{
                type: Input
            }], maxFontSize: [{
                type: Input
            }], height: [{
                type: Input
            }], width: [{
                type: Input
            }], showInfo: [{
                type: Output
            }], controllerDiv: [{
                type: ViewChild,
                args: ['controllerDiv']
            }] } });

class NgxFitTextModule {
}
NgxFitTextModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: NgxFitTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxFitTextModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: NgxFitTextModule, declarations: [NgxFittextComponent,
        FitLineComponent,
        FitTextComponent], exports: [NgxFittextComponent,
        FitLineComponent,
        FitTextComponent] });
NgxFitTextModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: NgxFitTextModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: NgxFitTextModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NgxFittextComponent,
                        FitLineComponent,
                        FitTextComponent
                    ],
                    imports: [],
                    exports: [
                        NgxFittextComponent,
                        FitLineComponent,
                        FitTextComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of ngx-fittext
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FitLineComponent, FitTextComponent, NgxFitTextModule, NgxFittextComponent, NgxFittextService };
